import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0c45da41"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Level Up!", -1))
const _hoisted_2 = { class: "highlight" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Keep up the good work", -1))
const _hoisted_4 = { class: "lottie-container" }
const _hoisted_5 = {
  ref: "lottie",
  style: {"width":"100%","height":"100%","object-fit":"cover","object-position":"center"},
  src: "/Lottie/level-up.json",
  autoplay: ""
}
const _hoisted_6 = { class: "button-container" }

import { computed } from "vue";
import { Modal } from "uiv";
import { Variant } from "../../typings/shared/levels-variant";


export default /*#__PURE__*/_defineComponent({
  __name: 'complete-level-modal',
  props: {
    modelValue: { type: Boolean },
    levelsCompleted: {},
    variant: {}
  },
  emits: ["close-complete-level-modal"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "2bd25908": (highlightColour.value)
}))

const props = __props;

const isDisplayed = computed(() => {
  return props.modelValue;
});

const emit = __emit;

const highlightColour = computed(() => {
  if (props.variant === "team") {
    return "#b0bb36";
  }
  if (props.variant === "user") {
    return "#FCAF17";
  }
  return "#000000";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    modelValue: isDisplayed.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isDisplayed).value = $event)),
    header: false,
    footer: false,
    class: "text-center"
  }, {
    default: _withCtx(() => [
      _createElementVNode("header", null, [
        _hoisted_1,
        _createElementVNode("p", null, [
          _createTextVNode(" Congratulations on completing "),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.levelsCompleted) + " level" + _toDisplayString(_ctx.levelsCompleted !== 1 ? "s" : "") + "!", 1)
        ]),
        _hoisted_3
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("lottie-player", _hoisted_5, null, 512)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-complete-level-modal'))),
          "data-test": "complete-level-modal-button"
        }, " Continue ")
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})